/**
 * layerFactory.js
 * Helper that builds a valid, fully-defaulted layer config object.
 * Pages call this to ensure they always provide the required shape.
 */
import { STATUS_COLORS } from '../constants/statusColors';

/**
 * Build a layer config object with sensible defaults.
 * @param {object} overrides - partial layer config from the page
 * @returns {object} complete layer config
 */
export function layerFactory(overrides = {}) {
  return {
    // Required by LayerManager
    id:          overrides.id          || 'unknown',
    title:       overrides.title       || 'Layer',
    description: overrides.description || '',
    color:       overrides.color       || STATUS_COLORS.NEUTRAL,

    // Display
    icon:        overrides.icon        || null,   // optional Vue component or data URI

    // Behaviour flags
    visible:     overrides.visible     !== undefined ? overrides.visible     : true,
    clustered:   overrides.clustered   !== undefined ? overrides.clustered   : false,
    searchable:  overrides.searchable  !== undefined ? overrides.searchable  : true,

    // Legend items auto-derived from color if not provided
    legend:      overrides.legend      || [{ color: overrides.color || STATUS_COLORS.NEUTRAL, label: overrides.title || 'Layer' }],

    // Marker data — array of marker objects
    markers:     overrides.markers     || [],
  };
}
